import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  key: 0,
  class: "mx-auto mt-4"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditCourseModal = _resolveComponent("EditCourseModal")!
  const _component_CourseCard = _resolveComponent("CourseCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_EditCourseModal, {
      ref: "editModal",
      course: _ctx.course,
      onEmitUpdatedCourse: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateCourse($event)))
    }, null, 8, ["course"]),
    _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.$t("messages.my courses")), 1),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course) => {
        return (_openBlock(), _createBlock(_component_CourseCard, {
          key: course.id,
          course: course,
          class: "my-3",
          onEditCourse: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleModal($event)))
        }, null, 8, ["course"]))
      }), 128)),
      (_ctx.courses.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("strong", null, [
              _createTextVNode(_toDisplayString(_ctx.$t("messages.There are no courses available")) + " ", 1),
              _hoisted_5
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}